"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var GRID_GAP = 10;
var HelpCenterWrapper = function HelpCenterWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "isLoading", _descriptor, _this);
      _initializerDefineProperty(_this, "loadFailed", _descriptor2, _this);
      _this.categoryRequestId = 0;
      _this.loadFaqCategories = function () {
        var requestId = ++_this.categoryRequestId;
        _this.isLoading = true;
        _this.loadFailed = false;
        _state.AppUI.faqCategoryStore.getIndex({
          timeout: _constants.Constants.FAQ_REQUEST_TIMEOUT,
          failureCallback: function failureCallback() {
            return _this.handleLoadFailure(requestId);
          },
          onRequestError: function onRequestError() {
            return _this.handleLoadFailure(requestId);
          }
        }, function (response) {
          return _this.handleLoadSuccess(requestId, response);
        });
      };
      _this.handleLoadSuccess = function (requestId, response) {
        if (requestId === _this.categoryRequestId) {
          _state.AppUI.faqCategoryStore.afterGetIndex(response);
          _this.isLoading = false;
        }
      };
      _this.handleLoadFailure = function (requestId) {
        if (requestId === _this.categoryRequestId) {
          _this.isLoading = false;
          _this.loadFailed = true;
        }
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        _state.AppUI.faqCategoryStore.clearIndexData();
        _state.AppUI.faqCategoryStore.clearShowData();
        this.loadFaqCategories();
      }
    }, {
      key: "gridItemWidth",
      get: function get() {
        return Math.floor((this.containerWidth - (this.numColumns - 1) * GRID_GAP) / this.numColumns);
      }
    }, {
      key: "gridItemMargins",
      get: function get() {
        var _this2 = this;
        var ary = [];
        (0, _lodash.times)(this.numGridItems, function (x) {
          if (_this2.numColumns === 1) {
            ary.push('0 0 10px 0');
          } else if (x % _this2.numColumns === 0) {
            ary.push('0 5px 10px 0');
          } else if (x % _this2.numColumns === _this2.numColumns - 1) {
            ary.push('0 0 10px 5px');
          } else if (_this2.numColumns === 3) {
            ary.push('0 5px 10px 5px');
          }
        });
        return ary;
      }
    }, {
      key: "containerWidth",
      get: function get() {
        return Math.min(_state.AppUI.layout.isMobile ? _state.AppUI.layout.viewportWidth : _state.AppUI.layout.viewportWidth - 20, 1160);
      }
    }, {
      key: "numColumns",
      get: function get() {
        if (this.containerWidth < 580) {
          return 1;
        } else if (this.containerWidth < 870) {
          return 2;
        }
        return 3;
      }
    }, {
      key: "numGridItems",
      get: function get() {
        return _state.AppUI.faqCategoryStore.indexData.length;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          faqCategories: _state.AppUI.faqCategoryStore.indexData,
          gridItemWidth: this.gridItemWidth,
          gridItemMargins: this.gridItemMargins,
          showSpinner: this.isLoading,
          loadFailed: this.loadFailed,
          retryLoad: this.loadFaqCategories
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "isLoading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "loadFailed", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "gridItemWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "gridItemWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "gridItemMargins", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "gridItemMargins"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "containerWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "containerWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numColumns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numColumns"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numGridItems", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numGridItems"), _class2.prototype), _class2)) || _class;
};
HelpCenterWrapper.displayName = 'HelpCenterWrapper';
var _default = exports["default"] = HelpCenterWrapper;